import client from 'app/client';
import { AddressDto, OperationResponse } from 'api/actor';
import { MandantSelection } from 'back-office/shared/components/mandants/mandantTypes';

/**
 * Création complète d'un PIM (Professionnel de l'Immobilier) : user ABP
 * (rôle PIM) + PM nature PIM + ligne Courtier + liaisons vers ses courtiers
 * mandants avec, pour chacun, les tunnels accordés VIA lui (granularité paire
 * mandant×tunnel). Comme MIA mais SANS ORIAS. Les habilitations dérivées sont
 * posées par le backend dans la même transaction.
 */
export interface CreatePimCommand {
  companyName: string;
  address?: AddressDto;
  /** Téléphone de l'entreprise (standard), facultatif. */
  phone?: string | null;
  /** Gérant juridique : civilité et mobile, requis. */
  gerant: { civiliteId: string; phone: string };
  registrationNumber: string;
  capital: number;
  rcsCity: string;
  rcsNumber: string;
  rcp?: string | null;
  complaintEmail: string;
  mandants: MandantSelection[];
  firstName: string;
  lastName: string;
  email: string;
  username: string;
  password: string;
  plateformeIds: string[];
}

export interface PimMandantDto {
  courtierId: string;
  label?: string | null;
  /** Tunnels accordés via ce mandant (sélections actives de la liaison). */
  tunnelIds: string[];
}

export interface PimListItemDto {
  id: string;
  courtierId: string;
  label: string;
  registrationNumber?: string;
  email?: string | null;
  phone?: string;
  creationDate: string;
  mandants: PimMandantDto[];
  /** OUs de rattachement du PIM (filtrage des mandants proposables). */
  plateformeIds: string[];
}

export interface SearchPimsResponse {
  items: PimListItemDto[];
  totalCount: number;
}

export interface SearchPimsCommand {
  searchString?: string;
  pageNumber: number;
  pageSize: number;
}

export interface UpdatePimMandantsCommand {
  mandants: MandantSelection[];
}

export async function createPim(command: CreatePimCommand): Promise<OperationResponse> {
  const { data } = await client.post<OperationResponse>('/backoffice/pims', command);
  return data;
}

export async function searchPims(command: SearchPimsCommand): Promise<SearchPimsResponse> {
  const { data } = await client.post<SearchPimsResponse>('/backoffice/pims/liste', command);
  return data;
}

/**
 * État cible des courtiers mandants du PIM. Les retraits déclenchent côté
 * backend la désactivation en cascade des habilitations tunnels orphelines
 * (le nombre est remonté dans response.notification).
 */
export async function updatePimMandants(
  pimCourtierId: string,
  command: UpdatePimMandantsCommand,
): Promise<OperationResponse> {
  const { data } = await client.put<OperationResponse>(
    `/backoffice/pims/${pimCourtierId}/mandants`,
    command,
  );
  return data;
}
